import React from 'react'
import { useTranslation } from 'react-i18next'
import './ClearableBadge.scss'

interface ClearableBadgeProps {
  selected: boolean
  number?: number
  onCleared?: () => void
}

const ClearableBadge: React.FC<ClearableBadgeProps> = ({ selected, number, onCleared }) => {
  const { t } = useTranslation()
  const active = selected || (number !== undefined && number > -1)
  const isNumbered = number !== undefined && number > -1

  if (!active) return null

  const handleClick = (event: React.MouseEvent) => {
    if (onCleared) {
      onCleared()
      event.stopPropagation()
      event.preventDefault()
    }
  }

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      if (onCleared) {
        onCleared()
        event.stopPropagation()
        event.preventDefault()
      }
    }
  }

  return (
    <span
      className="position-absolute top-0 start-100 translate-middle badge bg-secondary border border-light rounded-pill p-1 clearable-badge"
      title={t('clear')}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
    >
      {!isNumbered && selected && <i className="bi bi-check-lg check"></i>}
      {isNumbered && (
        <div className="number">
          {number}
          <span className="visually-hidden">selected</span>
        </div>
      )}
      <i className="bi bi-x-lg x"></i>
    </span>
  )
}

export default ClearableBadge
